// src/utils/posthog.ts
//
// posthog-js is pinned to 1.57.2 (matching trade-ui after Bjorn's 2026-05-06
// `fixing posthog data coming through` fix). Pre-1.190 — uses /decide/ instead
// of /flags/, which the self-hosted Stikland PostHog 401s on.
import posthog from 'posthog-js'

export function initPostHog() {
  const apiKey = process.env.REACT_APP_POSTHOG_API_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST;

  if (!apiKey || !host) {
    if (process.env.NODE_ENV !== 'test') {
      // eslint-disable-next-line no-console
      console.warn(
        '[PostHog] Skipping init — REACT_APP_POSTHOG_API_KEY and/or REACT_APP_POSTHOG_HOST are not set. ' +
        'Capture calls will be no-ops. See .env.example.'
      );
    }
    return;
  }

  posthog.init(apiKey, {
    api_host: host,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    capture_performance: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: { password: true, email: false },
      maskTextSelector: '.ph-mask',
      blockSelector: '.ph-block',
    },
    persistence: 'localStorage+cookie',
    cross_subdomain_cookie: true,
    secure_cookie: true,
    debug: false,
    loaded: (ph) => {
      if (process.env.NODE_ENV === 'development') ph.debug();
    },
  })

  // Tag every event with the storefront persona so PostHog Insights can
  // group by user_type (Trade / Public / Staff per the KPI cards) without
  // depending on posthog.identify(). Anonymous browsers default to PUBLIC;
  // upgrade to CONSUMER on successful login if/when we wire identify there.
  posthog.register({ user_type: 'PUBLIC' });
}

export default posthog;
